import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import clsx from 'clsx';

import { Drawer, List, Icon, Button } from '@material-ui/core';
import { ListItem, Typography } from '@mui/material';
import ListItemButton from '@mui/material/ListItemButton';
import MarkEmailUnreadIcon from '@mui/icons-material/MarkEmailUnread';
import { Stack } from '@mui/material';
import CalculateIcon from '@mui/icons-material/Calculate';
import InsightsIcon from '@mui/icons-material/Insights';
import ClickAwayListener from '@mui/base/ClickAwayListener';

import logo from '../../assets/logoMobile.jpg';
import logoMini from '../../assets/logoMobileSidebarCollapsed.jpg';
import leftArrow1 from '../../assets/leftArrow1.svg';
import rightArrow1 from '../../assets/rightArrow1.svg';
import AdvanceTabIcon from '../../assets/AdvanceTabIcon.svg';
import { SidebarProps } from 'src/interfaces/iproptypes';
import { SidebarItemType } from 'src/interfaces/idashboard';
import useStyles from './styles';
import SidebarItem from './SidebarItem';
import CurrencyChangeMenu from '../CurrencyChangeMenu';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import { useOpenOverviewOnboardingPage } from 'src/utils/hooks';
const sideBarIconStyle = { fontSize: 25, color: '#000', padding: '2 0' };

// main component

const sidebarItems: SidebarItemType[] = [
  {
    icon: <InsightsIcon style={sideBarIconStyle} />,
    name: 'Overview',
    isPage: false,
    stateName: 'main',
    listIndex: 0,
    children: [],
  },
  {
    icon: <CalculateIcon style={sideBarIconStyle} />,
    name: 'Calculator',
    isPage: false,
    stateName: 'estimator',
    listIndex: 1,
    children: [],
  },
];

const Sidebar = ({
  parent,
  handleSidebarClick,
  sidebarOpen,
  setSidebarOpen,
  matches,
  selectedSidebarIndex,
  handleSidebarListItemClick,
  currency,
  setCurrency,
  isUserVerified,
  setIsEmailVerifyModalOpen,
  dashboardState,
  setSubscriptionModalOpen,
  user,
}: SidebarProps) => {
  const classes = useStyles();
  const history = useHistory();
  const [sideBarReadyToCollapse, setSideBarReadyToCollapse] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setSideBarReadyToCollapse(sidebarOpen);
    }, 500);
  }, [sidebarOpen]);

  useEffect(() => {
    if (window.innerWidth < 1050) {
      setSidebarOpen(false);
    }
  }, [matches]);

  const currentPath = window.location.pathname;

  const isTopBannerOpen = useSelector((state: any) => state.dashboard.isTopBannerOpen);
  const openOverviewOnboardingPage = useOpenOverviewOnboardingPage();

  const handleClickAway = () => {
    if (matches && sideBarReadyToCollapse) {
      setSidebarOpen(false);
    }
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Drawer
        variant="permanent"
        classes={{
          paper: clsx(classes.paperDrawer, {
            [classes.drawerOpen]: sidebarOpen,
            [classes.drawerClose]: !sidebarOpen,
            [classes.bannerOpen]: isTopBannerOpen,
          }),
        }}
        className="sidebar-scroll"
      >
        {/* Button */}
        {sidebarOpen ? (
          <Icon
            className={classes.switch}
            aria-label="open drawer"
            onClick={() => setSidebarOpen(false)}
          >
            <img src={leftArrow1} />
          </Icon>
        ) : (
          <Icon
            className={classes.switchClosed}
            aria-label="open drawer"
            onClick={() => setSidebarOpen(true)}
          >
            <img src={rightArrow1} />
          </Icon>
        )}

        <Button
          className={classes.logoButton}
          onClick={() => {
            openOverviewOnboardingPage();
          }}
        >
          {sidebarOpen ? (
            <img src={logo} className={classes.logo} />
          ) : (
            <img src={logoMini} className={classes.logoMini} />
          )}
        </Button>

        {/* Dashboard */}
        <div>
          {sidebarItems.map((data, index) => {
            return (
              <SidebarItem
                item={data}
                isSubGroup={false}
                handleSidebarClick={handleSidebarClick}
                handleSidebarListItemClick={handleSidebarListItemClick}
                matches={matches}
                sidebarOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
                index={index}
                selectedSidebarIndex={selectedSidebarIndex}
                user={user}
              />
            );
          })}
        </div>

        {/* Email verification button */}
        {isUserVerified === false && (
          <List
            disablePadding={false}
            style={{
              position: 'relative',
              cursor: 'pointer',
              width: '100%',
              marginBottom: '20px',
            }}
            onClick={() => setIsEmailVerifyModalOpen(true)}
          >
            <ListItemButton
              style={{
                marginLeft: 'auto',
                marginRight: 'auto',
                color: '#000',
                width: '155px',
                animation: 'bounce-up 3.5s 5s ease-in-out infinite',
              }}
            >
              <Stack direction="row" justifyContent="center" alignItems="center" gap={1}>
                <MarkEmailUnreadIcon
                  style={{
                    color: '#000',
                    animation: 'shake-up-down 3.5s 5s ease-in-out infinite',
                  }}
                />
                {sidebarOpen && (
                  <Typography variant="body1" style={{ marginLeft: 0 }}>
                    Verify Email
                  </Typography>
                )}
              </Stack>
            </ListItemButton>
          </List>
        )}

        {matches && currency && (
          <List
            disablePadding={true}
            style={{
              position: 'relative',
              cursor: 'pointer',
              width: '100%',
              marginBottom: '20px',
            }}
          >
            <ListItem sx={{ paddingLeft: 0 }}>
              <CurrencyChangeMenu
                currency={currency}
                setCurrency={setCurrency}
                fullWidth={true}
                darkTheme={true}
              />
            </ListItem>
          </List>
        )}
      </Drawer>
    </ClickAwayListener>
  );
};

export default Sidebar;
